module.exports = new __parcel__URL__("incidents-page-table-skeleton.tpl.e8f337f1.svg").toString();